import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-arrow-svg',
  templateUrl: './arrow-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class ArrowSvgComponent {}
